import { render, staticRenderFns } from "./product-material.vue?vue&type=template&id=4900f22a&scoped=true&"
import script from "./product-material.vue?vue&type=script&lang=js&"
export * from "./product-material.vue?vue&type=script&lang=js&"
import style0 from "./product-material.vue?vue&type=style&index=0&id=4900f22a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900f22a",
  null
  
)

export default component.exports